export type SamSettings = {
  painPoint: string;
  valueProposition: string;
  metrics: string[];
  countries: number[];
};

export enum OnboardingStep {
  painPoint = 'painPoint',
  valueProposition = 'valueProposition',
  metrics = 'metrics',
  countries = 'countries',
}
